import {addToCart} from '@@/js/components/cart';

const tabToggles = document.querySelectorAll('[data-tab-toggle]');
const tabContent = document.querySelectorAll('[data-tab-content]');
const tabClose = document.querySelectorAll('[data-tab-close]');
const galleryButtons = document.querySelectorAll('[data-product-gallery]');
const form = document.querySelector('form.cart');

// We submit the cart form ourselves via fetch and rely on WC + MPC for
// server-side validation. Skip native HTML5 validation so a `quantity`
// auto-filled by the calculator beyond the stock-based `max` doesn't
// trigger "An invalid form control with name='quantity' is not focusable"
// and block the submit event before our handler runs.
if (form) form.noValidate = true;

tabClose && tabClose.forEach(tabClose => {
  tabClose.addEventListener('click', (e) => {
    const tabContent = tabClose.closest('[data-tab-content]');
    tabContent.classList.remove('is-tab-active');
  });
});

tabToggles && tabToggles.forEach(tabToggle => {
  tabToggle.addEventListener('click', (e) => {

    tabContent.forEach((tab) => {
      tab.classList.toggle('is-tab-active', tab.dataset.tabContent === tabToggle.dataset.tabToggle);

    })
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  });
});

galleryButtons && galleryButtons.forEach(galleryButton => {
  galleryButton.addEventListener('click', (e) => {
    const galleryDots = document.querySelectorAll('.flex-control-nav img');
    const index = [...galleryDots].findIndex(
      dot => dot.classList.contains('flex-active'));
    const isNext = galleryButton.dataset.productGallery === 'next';
    const nextIndex = (index + (isNext ? 1 : -1) + galleryDots.length) %
      galleryDots.length;
    galleryDots[nextIndex].click();
  });
});

form?.addEventListener('submit', (e) => {
  e.preventDefault();

  const productId = form.querySelector('[name="variation_id"]') ||
    form.querySelector('[name="product_id"]') ||
    form.querySelector('[name="add-to-cart"]');

  addToCart(
    productId.value,
    form.querySelector('[name="quantity"]').value,
    form,
  );
});

document.addEventListener('click', e => {
  if (e.target.matches('[data-quick-add-to-cart]')) {
    e.preventDefault();

    const form = e.target.closest('form');
    const productId = form.querySelector('[name="product_id"]') ||
      form.querySelector('[name="variation_id"]:checked');

    addToCart(
      productId.value,
      1,
    );
  }
});

// close active tab on ESC
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const activeTab = document.querySelector('[data-tab-content].is-tab-active');
    if (activeTab) {
      activeTab.classList.remove('is-tab-active');
    }
  }
});



